import React, { Component } from 'react';
import TaxReclaimGroupsPage from './tax-reclaim-group-html';
class TaxReclaimGroups extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <TaxReclaimGroupsPage
                />
            </div>
        )
    }
}
export default TaxReclaimGroups;